type Context = 'signal-agents';

type Section =
  | 'list'
  | 'notifications'
  | 'notifications-unread-count'
  | 'targets'
  | 'target-mapping'
  | 'templates'
  | 'template'
  | 'action-defaults'
  | 'webhook-defaults'
  | 'agent-activity';

type Value = `${Context}-${Section}`;

export const Keys: Record<Section, Value> = {
  list: 'signal-agents-list',
  targets: 'signal-agents-targets',
  'target-mapping': 'signal-agents-target-mapping',
  notifications: 'signal-agents-notifications',
  'notifications-unread-count': 'signal-agents-notifications-unread-count',
  templates: 'signal-agents-templates',
  template: 'signal-agents-template',
  'action-defaults': 'signal-agents-action-defaults',
  'webhook-defaults': 'signal-agents-webhook-defaults',
  'agent-activity': 'signal-agents-agent-activity',
};
